const realisations = () => {
  const block = document.querySelector(".realisations-block");
  if (!block) return;

  const filtres = block.querySelectorAll(".filtre");
  const items = block.querySelectorAll(".realisation");

  filtres.forEach((btn) => {
    btn.addEventListener("click", () => {
      const filter = btn.dataset.filter;

      filtres.forEach((f) => f.classList.remove("active"));
      btn.classList.add("active");

      items.forEach((item) => {
        const categories = item.dataset.categories.split(",");
        const match = filter === "all" || categories.includes(filter);

        if (match) {
          item.classList.remove("fade-out");
          item.classList.add("fade-in");
          item.classList.remove("hidden");
        } else {
          item.classList.add("fade-out");
          item.classList.remove("fade-in");
          setTimeout(() => {
            item.classList.add("hidden");
          }, 300);
        }
      });
    });
  });
};

realisations();

export default realisations;
